// src/api/demaService.ts
import apiClient from "./config";
import { CompanyResponse, SimilarCompaniesResponse } from "../types/interfaces";
import i18next from 'i18next';

export const getCompanies = async (): Promise<CompanyResponse[]> => {
  try {
    const response = await apiClient.get<CompanyResponse[]>("/dema/companies");
    return response.data;
  } catch (error) {
    throw error;
  }
};


export const getCompanyDetails = async (reportId: string): Promise<SimilarCompaniesResponse> => {
  try {
    const lang = i18next.language || 'es';
    const response = await apiClient.get<SimilarCompaniesResponse>(`/dema/company-details/${reportId}?lang=${lang}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};